"use strict";
// This file is automatically generated. Do not edit or commit.
// tslint:disable
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shadows = void 0;
exports.Shadows = {
    "shadow0": {
        "box-shadow": "none"
    },
    "shadow1": {
        "box-shadow": "0 3px 3px 0 rgba(30,30,30,0.16),0 1px 8px 0 rgba(30,30,30,0.08)"
    },
    "shadow2": {
        "box-shadow": "0 5px 10px 0 rgba(30,30,30,0.16),0 2px 8px 0 rgba(30,30,30,0.08)"
    },
    "shadow3": {
        "box-shadow": "0 8px 10px 1px rgba(30,30,30,0.16),0 4px 5px 0 rgba(30,30,30,0.08)"
    },
    "shadow4": {
        "box-shadow": "0 16px 24px 2px rgba(30,30,30,0.16),0 8px 10px 0 rgba(30,30,30,0.08)"
    },
    "dropshadow0": {
        "filter": "none"
    },
    "dropshadow1": {
        "filter": "drop-shadow(0 3px 3px rgba(30,30,30,0.16)) drop-shadow(0 1px 8px rgba(30,30,30,0.08))"
    },
    "dropshadow2": {
        "filter": "drop-shadow(0 5px 10px rgba(30,30,30,0.16)) drop-shadow(0 2px 8px rgba(30,30,30,0.08))"
    },
    "dropshadow3": {
        "filter": "drop-shadow(0 8px 10px rgba(30,30,30,0.16)) drop-shadow(0 4px 5px rgba(30,30,30,0.08))"
    },
    "dropshadow4": {
        "filter": "drop-shadow(0 16px 24px rgba(30,30,30,0.16)) drop-shadow(0 8px 10px rgba(30,30,30,0.08))"
    }
};
